import * as Yup from 'yup';

export const checkRequestSchema = Yup.object().shape({
  requestComment: Yup.string().required(),
  payeeName: Yup.string().required(),
  reason: Yup.string().required(),
  amountRequested: Yup.number().nullable().moreThan(0, 'Must be greater than 0').typeError('The amount invalid').required('The amount is required'),
});
